import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchTransporterOverview = createAsyncThunk(
  "transporter/fetchTransporterOverview",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getTransporterOverview();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch transporter overview");
    }
  }
);

export const fetchTransportersPaginated = createAsyncThunk(
  "transporter/fetchTransportersPaginated",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getTransportersPaginated(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch transporters");
    }
  }
);

export const createTransporter = createAsyncThunk(
  "transporter/createTransporter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.createTransporter(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create transporter");
    }
  }
);

export const fetchTransporterDetail = createAsyncThunk(
  "transporter/fetchTransporterDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.getTransporterDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch transporter detail");
    }
  }
);

export const updateTransporter = createAsyncThunk(
  "transporter/updateTransporter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.updateTransporter(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update transporter");
    }
  }
);

export const deleteTransporter = createAsyncThunk(
  "transporter/deleteTransporter",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deleteTransporter(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to delete transporter");
    }
  }
);

const initialState = {
  transporterOverviewData: null,
  transporterOverviewLoading: false,
  transporterOverviewError: null,
  transporterPaginatedData: null,
  transporterPaginatedLoading: false,
  transporterPaginatedError: null,
  transporterDetailData: null,
  transporterDetailLoading: false,
  transporterDetailError: null,
  createTransporterData: null,
  createTransporterLoading: false,
  createTransporterError: null,
  updateTransporterData: null,
  updateTransporterLoading: false,
  updateTransporterError: null,
  deleteTransporterLoading: false,
  deleteTransporterError: null,
};

const transporterSlice = createSlice({
  name: "transporter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransporterOverview.pending, (state) => {
        state.transporterOverviewLoading = true;
        state.transporterOverviewError = null;
      })
      .addCase(fetchTransporterOverview.fulfilled, (state, action) => {
        state.transporterOverviewLoading = false;
        state.transporterOverviewData = action.payload?.data || null;
        state.transporterOverviewError = null;
      })
      .addCase(fetchTransporterOverview.rejected, (state, action) => {
        state.transporterOverviewLoading = false;
        state.transporterOverviewError = action.payload;
      })
      .addCase(fetchTransportersPaginated.pending, (state) => {
        state.transporterPaginatedLoading = true;
        state.transporterPaginatedError = null;
      })
      .addCase(fetchTransportersPaginated.fulfilled, (state, action) => {
        state.transporterPaginatedLoading = false;
        state.transporterPaginatedData = action.payload?.data || null;
        state.transporterPaginatedError = null;
      })
      .addCase(fetchTransportersPaginated.rejected, (state, action) => {
        state.transporterPaginatedLoading = false;
        state.transporterPaginatedError = action.payload;
      })
      .addCase(fetchTransporterDetail.pending, (state) => {
        state.transporterDetailLoading = true;
        state.transporterDetailError = null;
      })
      .addCase(fetchTransporterDetail.fulfilled, (state, action) => {
        state.transporterDetailLoading = false;
        state.transporterDetailData = action.payload?.data || null;
        state.transporterDetailError = null;
      })
      .addCase(fetchTransporterDetail.rejected, (state, action) => {
        state.transporterDetailLoading = false;
        state.transporterDetailError = action.payload;
      })
      .addCase(createTransporter.pending, (state) => {
        state.createTransporterLoading = true;
        state.createTransporterError = null;
      })
      .addCase(createTransporter.fulfilled, (state, action) => {
        state.createTransporterLoading = false;
        state.createTransporterData = action.payload?.data || null;
        state.createTransporterError = null;
      })
      .addCase(createTransporter.rejected, (state, action) => {
        state.createTransporterLoading = false;
        state.createTransporterError = action.payload;
      })
      .addCase(updateTransporter.pending, (state) => {
        state.updateTransporterLoading = true;
        state.updateTransporterError = null;
      })
      .addCase(updateTransporter.fulfilled, (state, action) => {
        state.updateTransporterLoading = false;
        state.updateTransporterData = action.payload?.data || null;
        state.updateTransporterError = null;
      })
      .addCase(updateTransporter.rejected, (state, action) => {
        state.updateTransporterLoading = false;
        state.updateTransporterError = action.payload;
      })
      .addCase(deleteTransporter.pending, (state) => {
        state.deleteTransporterLoading = true;
        state.deleteTransporterError = null;
      })
      .addCase(deleteTransporter.fulfilled, (state) => {
        state.deleteTransporterLoading = false;
        state.deleteTransporterError = null;
      })
      .addCase(deleteTransporter.rejected, (state, action) => {
        state.deleteTransporterLoading = false;
        state.deleteTransporterError = action.payload;
      });
  },
});

export default transporterSlice.reducer;
